import { render, staticRenderFns } from "./SelectFieldWidget.vue?vue&type=template&id=506a155a&"
import script from "./SelectFieldWidget.vue?vue&type=script&lang=ts&"
export * from "./SelectFieldWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports